exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/_wks-ext.js
 ** module id = 205
 ** module chunks = 0
 **/